$('.js-copy-text').click(function () {
    let textToCopy = $(this).text().trim();
    copyToClipboard(textToCopy);
    $(this).addClass('_copied');
    setTimeout(() => {
        $(this).removeClass('_copied');
    }, 2000);
});

function copyToClipboard(text) {
    var $temp = $('<input>');
    $('body').append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
}



// WEBPACK FOOTER //
// ./_src/js/Copy.js